import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { parsePartialCount } from './helper/partialCount';

interface PartialCountDialogProps {
    total: number | null;
    saving: boolean;
    onClose: () => void;
    onSubmit: (count: number) => void;
}

const PartialCountDialog = ({ total, saving, onClose, onSubmit }: PartialCountDialogProps) => {
    const { t } = useTranslation(['Warehouses']);
    const [raw, setRaw] = useState('');
    const count = total == null ? null : parsePartialCount(raw, total);

    useEffect(() => {
        setRaw('');
    }, [total]);

    return (
        <Modal show={total != null} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('pendingIncome.partialTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">{t('pendingIncome.partialHint')}</p>
                <Form.Label htmlFor="pending-partial-count">{t('pendingIncome.partialCount')}</Form.Label>
                <Form.Control
                    id="pending-partial-count"
                    type="number"
                    min={1}
                    max={total != null ? total - 1 : undefined}
                    value={raw}
                    autoFocus
                    onChange={(event) => setRaw(event.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onClose} disabled={saving}>
                    {t('pendingIncome.partialCancel')}
                </Button>
                <Button
                    variant="primary"
                    disabled={saving || count == null}
                    onClick={() => {
                        if (count != null) onSubmit(count);
                    }}
                >
                    {t('pendingIncome.partialSave')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PartialCountDialog;
